<!-- 左侧菜单栏 -->

<template>
    <div
            class="e-menu-bar-container"
            @mouseover="mouseStatusChange(true)"
            @mouseout="mouseStatusChange(false)"
    >

        <transition
                name="block_slide"
                v-on:after-leave="transitionEnd"
        >
            <el-menu
                    ref="menu"
                    class="menu"
                    :background-color="Styles.menuBarBackground"
                    :text-color="Styles.applicationSideColor"
                    :active-text-color="Styles.menuBarActiveColor"
                    v-show="mouse_hover || !is_collapse"
                    :default-active="menu_default_active"
                    :default-openeds="menu_default_openeds"
                    @select="menuSelect"
            >
                <menu-item v-for="(item) of menus" :key="item.id" :menu_data="item"/>
            </el-menu>
        </transition>
    </div>
</template>

<script>
    import MenuItem from './menu-item'
    import {tree} from "@/apis/system/menu"

    let menuMap = {};

    export default {
        name: 'MenuBar',
        props: ['is_collapse', 'current_menu'],
        components: {
            'menu-item': MenuItem,
        },
        data() {
            return {
                mouse_hover: false,
                menus: [],
                menu_default_active: null,
                menu_default_openeds: null,
            }
        },
        watch: {
            current_menu() {
                this.expandMenu(this.current_menu);
            }
        },
        mounted() {
            tree().then(res => {
                let data = res.data;
                let recursion = (obj) => {
                    menuMap[obj.id] = obj;
                    if (obj.childList) {
                        obj.childList.forEach(recursion);
                    }
                };
                data.forEach(recursion);
                this.menus = data;
                this.expandMenu(this.current_menu);
            }).catch((ex) => {
                this.$message({
                    type: 'error',
                    message: ex.message
                });
            });
        },
        methods: {
            mouseStatusChange(hover) {
                this.mouse_hover = hover
            },
            expandMenu(currentMenu) {
                if (this.menus && this.menus.length > 0 && currentMenu) {
                    let openeds = [];
                    currentMenu.nav.forEach(obj => {
                        if (obj.id !== currentMenu.id) {
                            openeds.push(obj.id);
                        }
                    });

                    this.menu_default_openeds = openeds;
                    this.menu_default_active = currentMenu.id;
                }
            },
            transitionEnd() {
                this.$emit('transition_end', !this.mouse_hover && this.is_collapse)
            },
            menuSelect(index) {
                // 重复点击当前菜单不触发事件
                if (this.current_menu && this.current_menu.id === index) {
                    return;
                }

                // 获取当前菜单节点路径
                let nav = [];
                let menu = menuMap[index];
                let parentMenu = menuMap[menu.parentId];

                let recursion = (obj) => {
                    if (obj == null) {
                        return;
                    }
                    recursion(menuMap[obj.parentId]);
                    nav.push({
                        id: obj.id,
                        name: obj.name,
                        href: obj.href
                    });
                };
                recursion(parentMenu);

                this.$emit('menu_select', {
                    id: menu.id,
                    name: menu.name,
                    page: menu.href,
                    nav: nav,
                    append: []
                })
            }
        }
    }

</script>

<style lang="scss">
    @import "~@/assets/styles/application.scss";

    .el-menu-item.is-active {
        background-color: $menu_bar_active_background !important;
    }
</style>

<style scoped lang='scss'>
    @import 'style.scss';
</style>

